export default function PlanningHeader({
  summary,
  activeView,
  activeViewHint,
  viewTabs,
  plannerMessage,
  onViewChange,
  onRefresh,
}) {
  const RefreshIcon = viewTabs.refreshIcon;
  return (
    <section className="sticky top-0 z-20 rounded-[26px] border border-slate-200 bg-white/95 p-4 shadow-sm backdrop-blur">
      <div className="flex flex-col gap-4 xl:flex-row xl:items-start xl:justify-between">
        <div>
          <p className="text-xs font-semibold uppercase tracking-[0.24em] text-slate-500">
            Planning
          </p>
          <h1 className="mt-1 text-2xl font-semibold tracking-tight text-slate-950">
            Planning & Inzet
          </h1>
          <p className="mt-2 max-w-3xl text-sm text-slate-500">
            Plan werkbonnen, opnames en projecttaken op monteurs of ploegen. Bewaak capaciteit, conflicten en open werkvoorraad.
          </p>
        </div>

        <div className="grid grid-cols-2 gap-2 sm:grid-cols-4">
          {viewTabs.summaryTiles.map((tile) => (
            <SummaryTile
              key={tile.label}
              label={tile.label}
              value={summary[tile.valueKey]}
              icon={tile.icon}
            />
          ))}
        </div>
      </div>

      <div className="mt-4 flex flex-col gap-3 lg:flex-row lg:items-center lg:justify-between">
        <div className="flex flex-wrap gap-2">
          {viewTabs.tabs.map((tab) => {
            const Icon = tab.icon;
            const active = activeView === tab.key;
            const badgeCount = tab.key === "planning" ? summary.timeRequests : 0;
            return (
              <button
                key={tab.key}
                type="button"
                onClick={() => onViewChange(tab.key)}
                className={`inline-flex items-center gap-2 rounded-2xl px-4 py-2.5 text-sm font-semibold transition ${
                  active
                    ? "bg-slate-900 text-white"
                    : "border border-slate-200 bg-white text-slate-700 hover:bg-slate-50"
                }`}
              >
                <Icon size={15} />
                {tab.label}
                {badgeCount > 0 ? (
                  <span
                    className={`rounded-full px-2 py-0.5 text-[11px] font-semibold ${
                      active ? "bg-white/15 text-white" : "bg-amber-100 text-amber-800"
                    }`}
                  >
                    {badgeCount}
                  </span>
                ) : null}
              </button>
            );
          })}
        </div>

        <button
          type="button"
          onClick={onRefresh}
          className="inline-flex items-center gap-2 rounded-2xl border border-slate-200 bg-white px-4 py-2.5 text-sm font-semibold text-slate-700 hover:bg-slate-50"
        >
          <RefreshIcon size={15} />
          Verversen
        </button>
      </div>

      {activeViewHint ? (
        <div className="mt-3 rounded-2xl border border-slate-200 bg-slate-50 px-3 py-2 text-sm text-slate-700">
          {activeViewHint}
        </div>
      ) : null}

      {plannerMessage ? (
        <div className={`mt-4 rounded-2xl px-4 py-3 text-sm ${plannerMessage.tone}`}>
          {plannerMessage.text}
        </div>
      ) : null}
    </section>
  );
}

function SummaryTile({ label, value, icon: Icon }) {
  return (
    <div className="rounded-[18px] border border-slate-200 bg-slate-50 px-3 py-3">
      <div className="flex items-center justify-between">
        <span className="text-[11px] font-semibold uppercase tracking-[0.2em] text-slate-500">{label}</span>
        <Icon size={15} className="text-slate-400" />
      </div>
      <p className="mt-2 text-2xl font-semibold text-slate-950">{value}</p>
    </div>
  );
}
